// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hiddenRow[data-v-2f5b3d1c] {\n  border-collapse: collapse;\n  display: none;\n}\n.pad-date[data-v-2f5b3d1c] {\n  padding-left: 44px !important;\n}\n.pad-money[data-v-2f5b3d1c] {\n  padding-right: 20px !important;\n}\n.pad-text[data-v-2f5b3d1c] {\n  padding-left: 20px !important;\n}\n.is-divider[data-v-2f5b3d1c] {\n  margin: 1.2em 0;\n}\ntfoot tr td[data-v-2f5b3d1c] {\n  padding-right: 18px !important;\n}", ""]);
// Exports
module.exports = exports;
